<template>
  <div class="app-container">
    <BjRouteTabs :route-list="isVerify ? STOCK_VERIFY_ROUTE_LIST : []" />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      :before-query-search="beforeQuerySearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item label="预留锁定单号 " prop="code">
            <BjInput
              v-model="queryParams.code"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="仓库编码" prop="warehouseCode">
            <BjInput
              v-model="queryParams.warehouseCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="仓库名称" prop="warehouseIdList">
            <BjSelectWarehouse
              v-model="queryParams.warehouseIdList"
              multiple
              :type-code="['logic']"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="statusList">
            <BjSelectLov
              v-if="!isVerify"
              v-model="queryParams.statusList"
              multiple
              :option-list="isVerify ? STOCK_TRANSFER_VERIFY_TYPE_LIST : STOCK_LOCK_STATUS_LIST"
            /> </el-form-item
        ></el-col>

        <el-col :span="colSpan">
          <el-form-item label="生效时间">
            <el-date-picker
              v-model="queryParamsEffectiveTime"
              class="full-width"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :picker-options="$pickerOptions()"
              align="right"
              :start-placeholder="$t('form.startDateText')"
              :end-placeholder="$t('form.endDateText')"
              :default-time="['00:00:00', '23:59:59']"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.createTimeText')">
            <el-date-picker
              v-model="queryParamsTime"
              class="full-width"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :picker-options="$pickerOptions()"
              align="right"
              :start-placeholder="$t('form.startDateText')"
              :end-placeholder="$t('form.endDateText')"
              :default-time="['00:00:00', '23:59:59']"
            /> </el-form-item
        ></el-col>
      </template>

      <template v-slot:tableOperation>
        <el-col>
          <el-button
            v-if="!isVerify"
            v-permission:BusinessStockLockAdd
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('addText') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="filterLabels.includes(col.prop) && col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <span
                v-else-if="!isVerify && col.prop === 'code'"
                class="link"
                @click="onView(scope.row)"
              >
                {{ scope.row[col.prop] }}
              </span>
              <template v-else-if="col.prop === 'status'">
                {{ $t(STOCK_LOCK_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>

              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="filterLabels.includes(col.prop) && col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="scope">
              <!--
                状态：

待审核，该记录可作废

已审核，该记录可停用

已作废，该记录不可操作

停用，该记录可启用(前提条件生效时间没失效)
               -->
              <template v-if="!isVerify">
                <el-button
                  v-permission:BusinessStockLockIndex_Status
                  :disabled="scope.row.status !== 'success'"
                  type="text"
                  @click="onStatus('close', scope.row)"
                  >停用</el-button
                >
                <el-button
                  v-permission:BusinessStockLockIndex_Abandon
                  :disabled="scope.row.status !== 'wait'"
                  type="text"
                  @click="onStatus('abandon', scope.row)"
                  >作废</el-button
                >
                <el-button
                  v-permission:BusinessStockLockIndex_Status
                  :disabled="scope.row.status !== 'close'"
                  type="text"
                  @click="onStatus('start', scope.row)"
                  >{{ $t('enableText') }}</el-button
                >
              </template>
              <template v-else>
                <el-button
                  v-permission="isVerify ? 'BusinessStockVerifyLockView' : ''"
                  type="text"
                  @click="onView(scope.row)"
                  >{{ $t('viewText') }}</el-button
                >
                <el-button
                  v-if="scope.row.status == 'wait'"
                  v-permission:BusinessStockVerifyPlanIndex_Pass
                  type="text"
                  class="main-btn"
                  @click="onAudit('success', scope.row.id)"
                  >审核通过</el-button
                >
                <el-button
                  v-if="scope.row.status == 'wait'"
                  v-permission:BusinessStockVerifyPlanIndex_Reject
                  type="text"
                  @click="onAudit('fail', scope.row.id)"
                  >审核拒绝</el-button
                >
              </template>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <!-- <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" /> -->
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
// import DataForm from './components/DataForm.vue';
import {
  STOCK_VERIFY_ROUTE_LIST,
  STOCK_TRANSFER_VERIFY_TYPE_LIST,
  STOCK_LOCK_STATUS_LIST,
} from '@/utils/constants';
export default {
  name: 'BusinessStockLockIndex',
  components: {
    // DataForm,
  },
  mixins: [pageMiXin],
  props: {
    isVerify: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      STOCK_VERIFY_ROUTE_LIST,
      STOCK_TRANSFER_VERIFY_TYPE_LIST,
      STOCK_LOCK_STATUS_LIST,
      queryApi: stockApi.getReserveRecords,
      // 查询参数
      queryParams: {
        code: null,
        createEndDate: null,
        createStartDate: null,
        effectiveEndDate: null,
        effectiveStartDate: null,
        statusList: [],
        warehouseCode: null,
        warehouseIdList: [],
      },

      labelList: [
        { label: '预留锁定单号', prop: 'code', isCheck: true, disabled: false, width: 180 },
        { label: '预计预留数量', prop: 'planNum', isCheck: true, disabled: false },
        { label: '实际预留数量', prop: 'actuallyNum', isCheck: true, disabled: false },
        { label: '仓库编码', prop: 'warehouseCode', isCheck: true, disabled: false, width: 180 },
        { label: '仓库名称', prop: 'warehouseName', isCheck: true, disabled: false, width: 180 },
        { label: '生效时间', prop: 'effectiveDate', isCheck: true, disabled: false, width: 135 },
        { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false },

        { label: 'table.remarkText', prop: 'remark', isCheck: true, disabled: false },
        { label: 'table.createdByText', prop: 'createdName', isCheck: true, disabled: false, width: 135 },
        { label: 'table.createTimeText', prop: 'createDate', isCheck: true, disabled: false, width: 135 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 180 },
      ],

      queryParamsTime: null,
      queryParamsEffectiveTime: null,
    };
  },
  computed: {
    filterLabels() {
      if (this.isVerify) {
        return [
          'code',
          'planNum',
          'actuallyNum',
          'warehouseCode',
          'warehouseName',
          'effectiveDate',
          'status',

          'createdBy',
          'createDate',
          'bjTableAction',
        ];
      }
      return [
        'code',
        'planNum',
        'actuallyNum',
        'warehouseCode',
        'warehouseName',
        'effectiveDate',
        'status',

        'remark',
        'createdBy',
        'createDate',
        'bjTableAction',
      ];
    },
  },
  watch: {
    queryParamsTime(v) {
      this.queryParams.createStartDate = (v || [])[0];
      this.queryParams.createEndDate = (v || [])[1];
    },
    queryParamsEffectiveTime(v) {
      this.queryParams.effectiveStartDate = (v || [])[0];
      this.queryParams.effectiveEndDate = (v || [])[1];
    },
  },
  mounted() {},
  methods: {
    beforeQuerySearch(conditionObj) {
      if (
        this.isVerify &&
        ((Array.isArray(conditionObj.statusList) && conditionObj.statusList.length == 0) ||
          !conditionObj.statusList)
      ) {
        conditionObj.statusList = this.STOCK_TRANSFER_VERIFY_TYPE_LIST.map(e => e.value);
      }

      return new Promise(resolve => {
        resolve(conditionObj);
      });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = null;
      this.queryParamsEffectiveTime = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 禁用 */
    onStatus(flag, row) {
      const TEXT = this.STOCK_LOCK_STATUS_LIST.bjGet(flag);
      this.$confirm(`您正在变更状态为 ${TEXT}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            id: row.id,
            status: flag,
          });
        })
        .catch(() => {});
    },
    /** 新建 */
    onAdd() {
      this.$toPage('BusinessStockLockAdd');
    },
    /** 查看 */
    onView(row) {
      if (this.isVerify) {
        this.$toPage('BusinessStockVerifyLockView', { id: row.id });
      } else {
        this.$toPage('BusinessStockLockView', { id: row.id });
      }
    },
    onAudit(flag, id) {
      const TEXT = this.STOCK_LOCK_STATUS_LIST.bjGet(flag);
      this.$confirm(`您正在变更状态为 ${TEXT}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            id: id,
            status: flag,
          });
        })
        .catch(() => {});
    },
    operationApi(API_DATA) {
      stockApi.statusReserveRecords(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    // deleteApi(API_DATA) {
    //   stockApi.deleteOnlineShop(API_DATA).then(res => {
    //     if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
    //       this.$message.success(this.$t('toast.operationSuccessText'));
    //       setTimeout(() => {
    //         this.reFresh();
    //       }, 500);
    //     }
    //   });
    // },
    batchDeleteApi(API_DATA) {
      stockApi.detailReserveRecords(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
